function ProductHeader({ title, description }: { title: string; description: string }) {
  return (
    <article className="col-span-full mx-auto flex max-w-[800px] flex-col items-center justify-center gap-y-4">
      {title && (
        <h2
          id="product-section-title"
          className="col-span-full text-balance text-center text-H1 font-semibold tracking-normal text-WHITE sm:text-H1-Mobile"
        >
          {title}
        </h2>
      )}
      {description && (
        <p className="col-span-full text-center text-Body-Large font-normal tracking-normal text-WHITE sm:text-Body">{description}</p>
      )}
    </article>
  );
}

export default ProductHeader;
